/**
 * Standard image constants for story images across the application.
 * All story images (uploaded and default) should use these constants
 * to maintain consistent 3:4 aspect ratio.
 */

/**
 * Standard aspect ratio for all story images: 3:4 (0.75)
 * This is a common book cover ratio that works well across all views.
 */
export const STORY_IMAGE_ASPECT_RATIO = "3/4";

/**
 * Standard dimensions for default image generation.
 * Maintains 3:4 ratio with good resolution for display.
 * Width: 600px, Height: 800px (600 / 800 = 0.75 = 3:4)
 */
export const STORY_IMAGE_DIMENSIONS = {
  width: 600,
  height: 800,
} as const;

